import { useContext, useState } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import FacetDataContext from '~/contexts/FacetDataContext';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import LabelWithCount from './LabelWithCount';
import { CommonWrapper } from './styles';

const Cylinders = () => {
  const [show, setShow] = useState(false);
  const { facetData } = useContext(FacetDataContext);
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );

  return (
    <FilterDrawer
      dataQa="facet-cylinderCounts"
      facetContent={facetData.cylinderCounts?.buckets ?? []}
      facetName="Cylinders"
      scrollIntoView
      show={show}
      onToggle={() => {
        setShow(!show);
      }}
    >
      <CommonWrapper>
        {facetData.cylinderCounts?.buckets?.map(
          ({ count, displayName, key }) => (
            <Checkbox
              checked={appliedFilters.cylinderCounts?.includes(key)}
              facet="cylinderCounts"
              filter={key}
              id={`cylinderCounts-${key}`}
              key={key}
              label={<LabelWithCount count={count} displayName={displayName} />}
              onChange={() =>
                updateListFilter({
                  filterKey: 'cylinderCounts',
                  value: key
                })
              }
            />
          )
        )}
      </CommonWrapper>
    </FilterDrawer>
  );
};

export default Cylinders;
